import React from 'react';
import styled from 'styled-components';

export default function Error() {
  return (
    <Root>
      <Image src={require('./error.png')} />
      <Title>Token验证失败</Title>
    </Root>
  );
}

const Root = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const Image = styled.img`
  width: 140px;
  height: 140px;
  margin-bottom: 20px;
`;

const Title = styled.div`
  color: var(--td-text-color-secondary);
  font-size: 14px;
`;
